module.exports = __webpack_public_path__ + "static/docTorso.962ebac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/docTorso.png
// module id = ./src/media/docTorso.png
// module chunks = 2345137460201621000 2488159010210823000